var _script, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeasurewave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 211,
    height: 36,
    viewBox: "0 0 211 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-140 22H-112.5L-109.5 1L-104.5 33.5L-101.5 22H-55.5L-53 10L-48.5 31L-42.5 1L-39.5 35.5L-36 22H5.5L10 10L13 31.5L17.5 1L20 22H71",
    stroke: "#504F74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71 22H98.5L101.5 1L106.5 33.5L109.5 22H155.5L158 10L162.5 31L168.5 1L171.5 35.5L175 22H216.5L221 10L224 31.5L228.5 1L231 22H282",
    stroke: "#504F74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurewave);
export default __webpack_public_path__ + "static/media/measurewave.46d9d81c40ccf785bfeabaf51f87100b.svg";
export { ForwardRef as ReactComponent };